'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DRAG_MODIFIER_KEYS_SET = exports.DRAG_MODIFIER_KEYS_SET = 'DRAG_MODIFIER_KEYS_SET';

var MODIFIER_KEYS = exports.MODIFIER_KEYS = {
    ctrlKey: 'ctrlKey',
    shiftKey: 'shiftKey',
    altKey: 'altKey',
    metaKey: 'metaKey'
};

var MODIFIER_KEYS_NAMES = exports.MODIFIER_KEYS_NAMES = Object.keys(MODIFIER_KEYS);


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/dnd/modifierKeys/dragModifierKeysConstants.js
// module id = 172
// module chunks = 0